export default {
  title: 'Jak postrzegasz Early Stage?',
  content: 'Daj nam znać, czy rozwijamy się w dobrym<br> kierunku. Wypełnij ankietę do&nbsp;7&nbsp;maja&nbsp;2022.',
  button_label: 'Wypełnij ankietę',
  button_url: 'https://esrodzucz.webankieta.pl/',
};
